import {Card, Col, Row} from "react-bootstrap";

const UserProfileDetails = ({currentUser}) => {


    console.log('currentUser', currentUser)

    return (
        <Card className="card-primary">
            <Card.Header>
                <Card.Title>Meus dados</Card.Title>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col>
                        <b> Nome:</b> {currentUser.name}
                    </Col>
                    <Col>
                        <b> E-mail:</b> {currentUser.email}
                    </Col>
                    <Col>
                        <b> Empresa:</b> {currentUser.tenantName}
                    </Col>
                    <Col>
                        <b> Permissões:</b> {currentUser.roles.join(', ')}
                    </Col>
                </Row>
            </Card.Body>
        </Card>)

};
export default UserProfileDetails;
